import React, { useCallback } from "react"
import { SaveUrlModalsProps } from "./modal-save-url-types";
import { TitleStyled } from "./style-component";
import InputAction from "../../input-action/input-action";
import TextNoteWithProcess from "../../text-node-with-process/text-node-with-process";
import ModalWrapper from "../../modal-wrapper/modal-wrapper";

const ModalSaveUrl: React.FC<SaveUrlModalsProps> = ({
	open = false,
	process,
	socialMediaName,
	loading,
	setOpen,
	value,
	setValue,
	handleSubmitUrl,
	error = ''
}) => {

	const handleClose = useCallback(() => {
		if (!loading) {
			setOpen(false);
		}
	}, [setOpen, loading]);

	const handleSubmit = useCallback(async (val: string) => {
		await handleSubmitUrl?.(val);
	}, [handleSubmitUrl]);

  const validateSocialMediaUrl = (val: string) => {
    if (!val.startsWith('http')) return false;

    const urlPatterns: { [key: string]: string[] } = {
      'Facebook': ['facebook.com', 'fb.com'],
      'X': ['x.com', 'twitter.com'],
      'Twitter': ['twitter.com', 'x.com'],
      'Instagram': ['instagram.com'],
      'TikTok': ['tiktok.com'],
    };

    try {
      const urlObj = new URL(val);
      const hostname = urlObj.hostname.replace('www.', '');
      const isValid = urlPatterns[socialMediaName]?.some(domain => hostname.includes(domain)) ?? true;
      return !isValid && `La URL debe ser de ${socialMediaName}`;
    } catch {
      return "URL no valida";
    }
  };

  const validateSocialMediaUrlSecure = (val: string) => {
    if (val.startsWith('http:')) {
      return "La URL debe comenzar con https://";
    }
    if (val.startsWith('https://')) {
      if (!val.startsWith('https://')) {
        return "La URL debe empezar con https://";
      }

      const countHttps = val.split("https://").length - 1;
      const countDomain = val.split(socialMediaName.toLowerCase()).length - 1;
      if (countHttps > 1 || countDomain > 1) {
        return `La URL no debe contener múltiples https:// o múltiples dominios ${socialMediaName}`;
      }

      if (!val.toUpperCase().includes(socialMediaName.toUpperCase())) {
        return `La URL debe ser de ${socialMediaName}`;
      }
    }
    return false;
  };

	const customValidations = [
		validateSocialMediaUrlSecure,
		validateSocialMediaUrl,
	];

	return (
		<ModalWrapper
			open={open}
			title={
				<TitleStyled>Ingresa  tu <span className="brandColor3">usuario de {socialMediaName}</span> o <span className="brandColor3">el enlace de tu publicación</span> para validar tu participación</TitleStyled>
			}
			handleClose={handleClose}
		>
			<InputAction
				name="url"
				placeholder="https://example.com/..."
				textButton="Enviar"
				value={value}
				setValue={setValue}
				onExecute={handleSubmit}
				loading={loading}
				validations={customValidations}
			/>
			<TextNoteWithProcess type='url' process={process} loading={loading} customError={error} />
		</ModalWrapper>
	)
}

export default ModalSaveUrl;